<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 17:18:42
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchRecord\components\viewPunchRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-08 11:01:44
-->
<template>
  <normalDialog
    :dialog="show"
    :title="$t('label_essweb_punchRecord_list_dialog_viewPunchTitle')"
    @close="closeDialog"
    width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <noContent v-if="isLoading" />
      <v-form ref="form" v-if="!isLoading" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_punchRecord_list_dialog_staffLabel"
              v-model="user"
              readonly
              chips
              avatar
              small-chips
              two-line
              :items="users"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_dateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              dense
              single-line
              :value="
                $getDateTime(PunchRecordData.punch_utc_datetime, 'YYYY/MM/DD')
              "
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_timeLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              dense
              single-line
              :value="$getDateTime(PunchRecordData.punch_utc_datetime, 'HH:mm')"
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_siteNameLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              dense
              single-line
              :value="$getCommonLangValue(PunchRecordData.site_name)"
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_punchSourceLabel")
            }}</v-sheet>
            <v-select
              :items="[
                'label_essweb_punchRecord_list_appLabel',
                'label_essweb_punchRecord_list_dkjLabel',
              ]"
              readonly
              single-line
              :height="27"
              multiple
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="PunchRecordData.hitCard"
              :append-icon="''"
              dense
            >
              <template v-slot:no-data> <noContent /> </template>

              <template v-slot:item="{ item, index }">
                <span>{{ $t(item) }}</span>
              </template>
              >
              <template v-slot:selection="{ item, index }">
                <span>{{ $t(item) }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_criteriaLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              dense
              single-line
              :value="
                Number(PunchRecordData.punch_criteria_matched)
                  ? $t(
                      'message_essweb_punchRecord_list_tip_criteriaMatchedLabel'
                    )
                  : $t(
                      'message_essweb_punchRecord_list_tip_criteriaNotMatchedLabel'
                    )
              "
            >
              <template v-slot:prepend-inner>
                <svg-icon
                  className="mt-1"
                  size="26"
                  fill="transparent"
                  :iconClass="
                    Number(PunchRecordData.punch_criteria_matched)
                      ? 'Done'
                      : 'Alert'
                  "
                />
              </template>
            </v-text-field>
          </v-col>

          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="PunchRecordData.source && Number(PunchRecordData.source) == 0"
          >
            <v-container fluid class="grey lighten-4 rounded-lg pa-2 ma-0">
              <v-container fluid class="pa-0 ma-0 d-flex flex-row my-3">
                <v-sheet class="transparent flex-shrink-1" width="50%">
                  {{ $t("label_essweb_site_form_longtitudeLabel") }}:{{
                    PunchRecordData.longitude
                  }}
                </v-sheet>
                <v-sheet class="transparent flex-shrink-1" width="50%">
                  {{ $t("label_essweb_site_form_latitudeLabel") }}:{{
                    PunchRecordData.latitude
                  }}
                </v-sheet>
              </v-container>
              <v-container
                fluid
                style="position: relative"
                class="pa-0 ma-0 rounded-lg mrc-border-solid scroll_content_no"
              >
                <GmapMap
                  :center="center"
                  :zoom="18"
                  ref="punchmap"
                  :options="{
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    keyboardShortcuts: false,
                    gestureHandling: 'greedy',
                    fullscreenControl: false,
                    disableDefaultUi: false,
                  }"
                  map-type-id="roadmap"
                  style="width: 100%; height: 300px"
                >
                  <GmapMarker
                    :option="{ animation: 'drop', shape: 'circle' }"
                    :position="markers"
                    :clickable="true"
                    :icon="makericon"
                    :draggable="false"
                    @click="setCenter(markers)"
                  />
                </GmapMap>
              </v-container>
            </v-container>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_tagLabel")
            }}</v-sheet>
            <v-select
              :items="[
                'label_essweb_punchRecord_list_tag_workFromHomeLabbel',
                'label_essweb_punchRecord_list_tag_fieldServiceLabel',
              ]"
              readonly
              single-line
              multiple
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              chips
              v-model="PunchRecordData.tag"
              :append-icon="''"
              dense
            >
              <template v-slot:no-data> <noContent /> </template>

              <template v-slot:selection="{ item, index }">
                <v-chip
                  text-color="white"
                  :color="
                    $getTagColors(
                      $card_line_colors,
                      item ==
                        'label_essweb_punchRecord_list_tag_workFromHomeLabbel'
                        ? 'is_work_from_home_1'
                        : 'is_out_of_office_1'
                    )
                  "
                >
                  {{ $t(item) }}
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="PunchRecordData.attachments"
          >
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_attachmentLabel")
            }}</v-sheet>
            <ImgDragUpdate
              :defaultImageList="PunchRecordData.attachments"
              disabled
              :closePop="closePop"
            />
            <!-- <v-list v-if="PunchRecordData.punch_attachment_url">
              <v-list-item
                two-line
                v-for="(item, index) in PunchRecordData.punch_attachment_url"
                :key="index"
              >
                <v-list-item-avatar tile>
                  <v-img :src="item"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            -->
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchRecord_list_dialog_messageLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              dense
              single-line
              :value="PunchRecordData.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </normalDialog>
</template>
<script>
import makericon from "@/assets/AttendancePoint.png";
// import makericon from "@/assets/place.png";
import { gmapApi } from "vue2-google-maps";
import { mapGetters } from "vuex";
export default {
  name: "viewPunchRecord",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: String },
  },
  computed: {
    ...mapGetters(["AppInfo", "isLoading"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      PunchRecordData: { attachments: [] },
      users: [],
      showMap: true, //2020-09-27不显示地图
      closePop: false,
      google: null,
      makericon: makericon,
      user: null,
      markers: null,
      center: { lat: 1.312878, lng: 103.837811 },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
      }
    },
    curUuid(val) {
      if (val) {
        this.getDetail(val);
      }
    },
  },
  mounted() {
    const that = this;
    if (
      this.curAppInfo["user"]["latitude"] != undefined &&
      this.curAppInfo["user"]["longitude"] != undefined
    ) {
      this.center = {
        lat: Number(this.curAppInfo["user"]["latitude"]),
        lng: Number(this.curAppInfo["user"]["longitude"]),
      };
    }
    this.$gmapApiPromiseLazy().then(() => {
      that.google = new gmapApi();
    });
  },
  methods: {
    closeDialog: function () {
      this.closePop = !this.closePop;
      this.$emit("close");
    },
    setCenter: function (position) {
      const that = this;
      this.$refs.punchmap.$mapPromise.then((map) => {
        map.setCenter(position);
        that.center = position;
      });
    },
    getDetail: function (uuid) {
      const that = this;
      that.PunchRecordData.attachments = [];
      this.$Request({
        method: "POST",
        table: "ess_punch_records_master",
        url: "/punch-record/get-punch-record-details/",
        data: { uuid: uuid },
      }).then((res) => {
        that.markers = {
          lat: Number(res.data.latitude),
          lng: Number(res.data.longitude),
        };
        that.center = {
          lat: Number(res.data.latitude),
          lng: Number(res.data.longitude),
        };
        res.data["tag"] = [];
        if (Number(res.data["is_work_from_home"])) {
          res.data["tag"].push(
            "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
          );
        }
        if (Number(res.data["is_out_of_office"])) {
          res.data["tag"].push(
            "label_essweb_punchRecord_list_tag_fieldServiceLabel"
          );
        }
        res.data["hitCard"] = [];
        if (Number(res.data["source"] == 1)) {
          res.data["hitCard"].push("label_essweb_punchRecord_list_dkjLabel");
        }
        if (Number(res.data["source"] == 0)) {
          res.data["hitCard"].push("label_essweb_punchRecord_list_appLabel");
        }
        that.users = [
          {
            staff_avatar: res.data.mrbase_sys_staffs.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.mrbase_sys_staffs.preferred_name,
          },
        ];
        if (res.data["attachments"]) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          res.data["attachments"] = [];
        }
        that.user = res.data.uuid;
        that.PunchRecordData = res.data;
        // that.setCenter(that.markers); //2020-09-27不显示地图//2020-02-22显示地图mel brain
      });
    },
  },
};
</script>
